export const Footer = () => {
  return (
    <footer className="flex w-full items-center justify-center">
      <span className="relative flex items-center justify-center gap-2 rounded-3xl bg-[rgba(28,18,30,0.20)] px-2 py-3 text-sm font-medium backdrop-blur-sm sm:p-4">
        Built by Pavel Sukhachev
      </span>
    </footer>
  );
};
